import React from 'react';
import { Box } from '@hz-design-system/web-ui';
import { ListingDetailsButton, ListingPrice, ListingTitle } from '@/client/components/ListingsNew/components';

import Classes from './ListingTitlePriceDetailsButton.module.scss';

interface ListingTitlePriceDetailsButtonProps {
  title: string;
  price: string;
  isDetailsOpen: boolean;
  shouldDisplayExtendedContent?: boolean;
  setIsDetailsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ListingTitlePriceDetailsButton: React.FC<ListingTitlePriceDetailsButtonProps> = ({
  title,
  price,
  isDetailsOpen,
  shouldDisplayExtendedContent = false,
  setIsDetailsOpen,
}) => {
  return (
    <Box as="div" name="Listing-title-price-details" className={Classes['hz-Listing-title-price-details']}>
      <ListingTitle.Regular title={title} strong />
      <Box
        as="div"
        name="Listing-price-extended-details-button"
        className={Classes['hz-Listing-price-extended-details-button']}
      >
        <ListingPrice price={price} />
        {shouldDisplayExtendedContent && (
          <ListingDetailsButton isDetailsOpen={isDetailsOpen} setIsDetailsOpen={setIsDetailsOpen} />
        )}
      </Box>
    </Box>
  );
};

export default ListingTitlePriceDetailsButton;
